import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';
import { JhiEventManager } from '../../shared/core-utils';
import { Router } from '@angular/router';
import { ParamContext } from '../../shared/service/param.context';
import { GermplasmListTreeTableComponent } from '../../shared/tree/germplasm/germplasm-list-tree-table.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../shared/alert/alert.service';

@Component({
    selector: 'jhi-specify-entries-tab',
    styleUrl: './specify-entries-tab.component.scss',
    templateUrl: './specify-entries-tab.component.html',
})
export class SpecifyEntriesTabComponent implements OnInit, OnDestroy {

    @Input() isForTestEntries: boolean;
    selectorTarget: string;

    private subscriptionsManager: SubscriptionsManager = new SubscriptionsManager();

    constructor(private eventManager: JhiEventManager,
                private router: Router,
                private alertService: AlertService,
                public paramContext: ParamContext,
                private activeModal: NgbActiveModal,
                private modalService: NgbModal) {
    }

    ngOnInit() {
        this.registerGermplasmSelectorSelected();
    }

    ngOnDestroy(): void {
        this.subscriptionsManager.unsubscribeAll();
    }

    openGermplasmSelector(selector: string): void {
        this.selectorTarget = selector;
        this.router.navigate(['/', { outlets: { popup: 'germplasm-selector-dialog' } }], {
            queryParamsHandling: 'merge',
            queryParams: {
                cropName: this.paramContext.cropName,
                loggedInUserId: this.paramContext.loggedInUserId,
                programUUID: this.paramContext.programUUID,
                selectMultiple: true
            }
        });
    }

    registerGermplasmSelectorSelected() {
        this.subscriptionsManager.add = this.eventManager.subscribe('germplasmSelectorSelected', (event) => {
            if (event.content && this.selectorTarget) {
                const selectedGids = event.content.split(',');
                const content = {
                    'isForTestEntries': this.selectorTarget === 'test',
                    selectedGids
                };
                this.eventManager.broadcast({ name: 'addGermplasmToEntries', content });
                this.selectorTarget = null;
            }
        });
    }

    browseList() {
        const modalRef = this.modalService.open(GermplasmListTreeTableComponent as Component, { size: 'xl', backdrop: 'static' });
        modalRef.componentInstance.selectionMode = 'single';
        modalRef.componentInstance.isFolderSelectionMode = false;
        modalRef.result.then((germplasmLists) => {
            if (germplasmLists && germplasmLists.length === 0) {
                this.alertService.error('select.list.error');
            } else {
                if (germplasmLists && germplasmLists.length > 0) {
                    const listId = germplasmLists[0].id;
                    const content = {
                        'isForTestEntries': this.isForTestEntries,
                        listId
                    };
                    this.eventManager.broadcast({ name: 'addListToEntries', content });
                }
            }
            this.activeModal.close();
        }, () => this.activeModal.dismiss());
    }

}
